import { render, staticRenderFns } from "./bstlxc.vue?vue&type=template&id=24816f5f&scoped=true"
import script from "./bstlxc.vue?vue&type=script&lang=js"
export * from "./bstlxc.vue?vue&type=script&lang=js"
import style0 from "./bstlxc.vue?vue&type=style&index=0&id=24816f5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24816f5f",
  null
  
)

export default component.exports